import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  UpdateNoticeListMutation,
  UpdateNoticeListMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { EventData, EventNames, useTracking } from "lib/tracking";
import { useGraphQlMutation } from "../../useGraphQlClient";
import { NoticeListIdentity } from "./useNoticeLists";

const updateNoticeListMutation = graphql(`
  mutation updateNoticeList($input: UpdateNoticeListInput!) {
    updateNoticeList(input: $input) {
      id
      name
    }
  }
`);

/** `list` is the list before the rename; the response carries the new name. */
type TrackingContext = {
  list: NoticeListIdentity;
  trackingData?: EventData;
};

export function useRenameNoticeList(
  { list, trackingData }: TrackingContext,
  options?: UseMutationOptions<
    UpdateNoticeListMutation,
    unknown,
    UpdateNoticeListMutationVariables,
    unknown
  >,
) {
  const { logEvent } = useTracking();
  const queryClient = useQueryClient();
  return useGraphQlMutation(updateNoticeListMutation, {
    ...options,
    onSuccess: async (data, vars, ctx) => {
      await queryClient.invalidateQueries(["noticeLists"]);
      logEvent(EventNames.listUpdated, {
        ...trackingData,
        "Existing List name": list.name,
        "Existing List id": list.id,
        "New List name": data.updateNoticeList.name,
      });
      options?.onSuccess?.(data, vars, ctx);
    },
  });
}
